import * as React from 'react';
import { Input, Col, Radio } from 'antd';
// const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
export default class InsertRadio extends React.Component<any> {
    constructor(props: any) {
        super(props);
    }
    // // change 事件处理
    changeHandler = (e: any) => {
        const { onChange} = this.props;
        onChange && onChange(e.target.value);
    };

    getClassName = (base: string): string => {
        const {className}=this.props;
        const classes = [base];
        className && classes.push(className);
        return classes.join(' ');
    };
    render() {
        const { labelBefore,options, labelAfter, tips, disabled, vertical,initialValue} = this.props;
        const verticalStyle = {
            display: 'block'
        };
        return (
            <Input.Group>
                {labelBefore && <Col span={6}><span>{labelBefore}</span></Col>}
                <Col span={8}>
                 <RadioGroup className={this.getClassName('RadioGroup')} defaultValue={initialValue} onChange={this.changeHandler} disabled={disabled}>
                {options.map((item: any, index: number) => (
                    <Radio style={vertical ? verticalStyle : null}
                           disabled={item.disabled}
                           value={item.value}
                           checked={item.checked}
                           key={index}>
                        {item.label}
                    </Radio>
                ))}
            </RadioGroup>
                    <span>{labelAfter}</span>
                </Col>
                <Col push={labelBefore ? 0 : 6} span={10}><span style={{ marginLeft: 24, display: 'inline-block' }}>{tips}</span></Col>
            </Input.Group>
        );
    }
}
